<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M8.852,16.567a.5.5,0,0,1,0,.707L2.564,23.561A1.5,1.5,0,0,1,.445,21.442l6.287-6.289a.5.5,0,0,1,.706,0Z"/><path d="M22.459,1.535C19.814-1.11,14.651-.251,10.95,3.45S6.39,12.314,9.035,14.959s7.808,1.786,11.509-1.915S25.1,4.18,22.459,1.535ZM11.3,13.028a.25.25,0,0,1-.337-.338A23.376,23.376,0,0,1,15.04,7.541a23.38,23.38,0,0,1,5.15-4.074.249.249,0,0,1,.337.337,23.38,23.38,0,0,1-4.074,5.15A23.42,23.42,0,0,1,11.3,13.028Zm1.059-8.165A9.533,9.533,0,0,1,17.8,2.024a.25.25,0,0,1,.166.456A32.973,32.973,0,0,0,9.98,10.464a.25.25,0,0,1-.456-.167A9.536,9.536,0,0,1,12.363,4.863ZM13.7,14.47a.25.25,0,0,1-.167-.456,32.008,32.008,0,0,0,4.337-3.647,32.048,32.048,0,0,0,3.647-4.336.25.25,0,0,1,.456.166,9.533,9.533,0,0,1-2.839,5.434A9.533,9.533,0,0,1,13.7,14.47Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'kitchenware-whisk',
    },
    name: {
      type: String,
      required: false,
      default: 'KitchenwareWhisk',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>